import React, { useContext } from "react";
import {UmbracoValues} from "../Memory/MemoryGame"

const GameDescription = (props) => {

    const umbracoValues = useContext(UmbracoValues);

    return(
        <div className="game-description-container">
            <picture className="game-description-image">
                <img src={`${umbracoValues.image}?format=webp&quality=80`} loading="lazy" />
            </picture>
            <div className="game-description-container__text-container">
                <h3>{umbracoValues.descriptionTitle}</h3>
                <p>{umbracoValues.description}</p>
            </div>
        </div> 
    );
};

export default GameDescription;